import React, { useEffect, useState } from 'react'
import Api from '../../../../services/Api'
import { getTokenUri } from '../../../../services/NFTMarketPlace/Graphquery'
import NFTImageSkeleton from '../../components/NFTImageSkeleton'
import { IDeproApeCryptoClubCard } from '../Cards/DeproApeCryptoClubCard'
import { IActivityDetail } from './ActivityDetail'
import BaseActivity from './BaseActivity'


export default function DeproApeCryptoClubActivtyDetail({ collection, historyItem, chainId }: IActivityDetail) {
  const { tokenId } = historyItem
  const [tokenUri, setTokenUri] = useState('')
  const [detailTokenItem, setDetailTokenItem] = useState<IDeproApeCryptoClubCard | null>(null)

  useEffect(() => {
    if (tokenId !== undefined && tokenId !== null && !tokenUri) {
      getTokenUri(collection.tokenAddress, tokenId).then(res => {
        if (res) {
          setTokenUri(res)
        } else {
          setTokenUri(`https://ipfs.io/ipfs/QmeSjSinHpPnmXmspMjwiXyN6zS4E9zccariGR3jxcaWtq/${tokenId}`)
        }
      })
    }
    if (tokenUri) {
      Api.get(tokenUri.replace('ipfs://', 'https://ipfs.io/ipfs/')).then((tokenResult: any) => setDetailTokenItem(tokenResult))
    }
  }, [tokenUri, collection.tokenAddress, tokenId])

  const tokenName = detailTokenItem ? `${collection.name} #${tokenId}` : collection.name

  return (
    <BaseActivity chainId={chainId} historyItem={historyItem} collection={collection} tokenName={tokenName}>
      {detailTokenItem ? <img src={detailTokenItem.image.replace('ipfs://', 'https://ipfs.io/ipfs/')} alt={tokenName} /> : <NFTImageSkeleton />}
    </BaseActivity>
  )
}